module.exports = __webpack_public_path__ + "static/media/unplaced-order.4f439b1c.svg";